// @flow
import { type ActionType } from 'redux-actions';
import {
  requestChannelContent,
  receiveChannelContent,
} from './channelContentActions';
import { call, select, takeLatest, put } from 'redux-saga/effects';
import { selectToken } from 'ducks/SagaUtils';
import { addItemsTask } from 'ducks/coreDataSaga';

function* fetchChannelContent(
  action: ActionType<typeof requestChannelContent>
) {
  const { apiMethod, channelName, endDateTime } = action.payload;
  const token = yield select(selectToken);

  try {
    const response = yield call(apiMethod, token, endDateTime);

    const itemsToPut = yield call(addItemsTask, {
      data: { items: response },
    });

    yield put.resolve(receiveChannelContent(channelName, itemsToPut.items));
  } catch (err) {
    console.error(err);
    yield put.resolve(receiveChannelContent(channelName, err));
  }
}

export default function*(collectionId: string): Generator<*, *, *> {
  yield takeLatest(requestChannelContent, fetchChannelContent);
}



// WEBPACK FOOTER //
// ./src/containers/channels/ducks/channelContentSaga.js